import { render, staticRenderFns } from "./PostFitOutCommentHistory.vue?vue&type=template&id=23530194&scoped=true&"
import script from "./PostFitOutCommentHistory.vue?vue&type=script&lang=js&"
export * from "./PostFitOutCommentHistory.vue?vue&type=script&lang=js&"
import style0 from "./PostFitOutCommentHistory.vue?vue&type=style&index=0&id=23530194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23530194",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23530194')) {
      api.createRecord('23530194', component.options)
    } else {
      api.reload('23530194', component.options)
    }
    module.hot.accept("./PostFitOutCommentHistory.vue?vue&type=template&id=23530194&scoped=true&", function () {
      api.rerender('23530194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/postFitOutLetter/PostFitOutCommentHistory.vue"
export default component.exports